export enum UserRoleId {
  ReportGenerator = '645f153b-943f-4955-9c6c-ebe5a83db475',
  SysAdmin = '769704ce-ce9a-4066-bc88-5a7911aefabc',
  PartnerAdmin = '0f16e94a-b09b-4755-aca9-169b78d67d32',
  PartnerTechnician = '8e1a00a6-b265-478a-97a1-75ac69b6f758',
  OrganisationAdmin = '856e060a-f576-4b32-94b9-eee42cdd2101',
  OrganisationUser = 'e474450b-9038-45d8-b6a9-227327648f1b',
  SiteFuelDataContributor = '1a03d59e-28ec-4538-ad6c-b56d6569d324',
  SiteUser = 'bca6b284-a22d-4ca8-aa00-257b224f09fc',
  FuelDataContributor = '152b26ef-9d7e-44d3-9a36-14aa1fc957f4',
}
